angular.module("eficienciaFiscalModule")
    .component("centralAlertas", {
        transclude: true,
        bindings: {
            contratoId: '<'
        },
        template: `
        <div>
            <alerta-filter contrato-id="$ctrl.contratoId" ng-model="$ctrl.filter"></alerta-filter>
            <alerta-list contrato-id="$ctrl.contratoId" filter="$ctrl.filter"></alerta-list>
        </div>
        `
    })
